// extracted by mini-css-extract-plugin
export var header = "_s9-1";
export var maskBottom = "_s9-6";
export var maskMiddle = "_s9-7";
export var maskTop = "_s9-5";
export var root = "_s9-0";
export var scrollDownButton = "_s9-3";
export var scrollDownButtonHidden = "_s9-4";
export var viewport = "_s9-2";